import { Component, Input, OnInit, OnDestroy, signal } from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  imports: [CdkTrapFocus]
})
export class LoadingOverlayComponent implements OnInit, OnDestroy {
  @Input() loadingMessage: string = 'Loading...';
  @Input() delay: number = 200;

  visible = signal(false);
  private timer: ReturnType<typeof setTimeout> | null = null;

  /**
   * Initializes the loading overlay and sets a timer to display it after the specified delay.
   */
  ngOnInit(): void {
    this.timer = setTimeout(() => this.visible.set(true), this.delay);
  }

  /**
   * Cleans up the timer when the component is destroyed to prevent memory leaks.
   */
  ngOnDestroy(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
